import { dataSourcesStardogRequestDispatchers } from 'src/actions/data-sources/actionCreators';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshDataSourceTables =
  (
    dataSourceId: string,
    { includeOptions = false }: { includeOptions?: boolean } = {}
  ) =>
  async (_: AppDispatch, getState: ReduxStateGetter) => {
    const state = getState();
    const { connection } = state.connections;
    if (!connection) {
      return;
    }

    const isCatalogSupported = isStardogFeatureSupportedSelector(
      'isCatalogSupported',
      connection
    )(state);

    const isDataSourceTablesEndpointSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceTablesEndpointSupported',
        connection
      )(state);

    await dataSourcesStardogRequestDispatchers.requestDataSourceInfo(
      dataSourceId
    );

    // Callers refreshing because the data source itself changed (e.g. the
    // "Refresh Data Source metadata" button) opt in to re-reading the options
    // so a changed previews-disabled flag is picked up — requestDataSourceInfo
    // preserves the cached options, so they must be fetched explicitly.
    if (includeOptions) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceOptions(
        dataSourceId,
        connection
      );
    }

    if (!isDataSourceTablesEndpointSupported) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTableMetadata(
        dataSourceId,
        isCatalogSupported
      );
    } else {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTables(
        dataSourceId,
        isCatalogSupported
      );
    }
  };
